module.exports = __webpack_public_path__ + "img/2024-14.812faa3d.jpg";